import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLovable: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconLovable"><Path fillRule="evenodd" clipRule="evenodd" d="M8.5509 2.19C11.6166 2.19 14.1018 4.68178 14.1018 7.75553V9.87078H15.9491C19.0149 9.87078 21.5 12.3626 21.5 15.4363C21.5 18.5101 19.0149 21.0018 15.9491 21.0018H3V7.75553C3 4.68178 5.48522 2.19 8.5509 2.19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLovable;
